import { SVGProps } from 'react';

export default function Prepare1(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3395)">
        <path
          d="M19.1667 15H6.66667C5.28833 15 4.16667 13.8783 4.16667 12.5V3.33333C4.16667 1.495 2.67167 0 0.833333 0C0.61232 0 0.400358 0.0877974 0.244078 0.244078C0.0877974 0.400358 0 0.61232 0 0.833333C0 1.05435 0.0877974 1.26631 0.244078 1.42259C0.400358 1.57887 0.61232 1.66667 0.833333 1.66667C1.7525 1.66667 2.5 2.41417 2.5 3.33333V12.5C2.50094 13.3105 2.73785 14.1031 3.1818 14.7812C3.62575 15.4592 4.25753 15.9934 5 16.3183V17.0833C5 18.6917 6.30833 20 7.91667 20C9.525 20 10.8333 18.6917 10.8333 17.0833V16.6667H13.3333V17.0833C13.3333 18.6917 14.6417 20 16.25 20C17.8583 20 19.1667 18.6917 19.1667 17.0833V16.6667C19.3877 16.6667 19.5996 16.5789 19.7559 16.4226C19.9122 16.2663 20 16.0543 20 15.8333C20 15.6123 19.9122 15.4004 19.7559 15.2441C19.5996 15.0878 19.3877 15 19.1667 15ZM9.16667 17.0833C9.16667 17.7725 8.60583 18.3333 7.91667 18.3333C7.2275 18.3333 6.66667 17.7725 6.66667 17.0833V16.6667H9.16667V17.0833ZM17.5 17.0833C17.5 17.7725 16.9392 18.3333 16.25 18.3333C15.5608 18.3333 15 17.7725 15 17.0833V16.6667H17.5V17.0833ZM9.16667 13.3333H15.8333C17.6717 13.3333 19.1667 11.8383 19.1667 10V5.83333C19.1667 3.995 17.6717 2.5 15.8333 2.5H9.16667C7.32833 2.5 5.83333 3.995 5.83333 5.83333V10C5.83333 11.8383 7.32833 13.3333 9.16667 13.3333ZM11.6667 4.16667H13.3333V6.66667H11.6667V4.16667ZM7.5 5.83333C7.5 4.91417 8.2475 4.16667 9.16667 4.16667H10V6.66667C10 7.58583 10.7475 8.33333 11.6667 8.33333H13.3333C14.2525 8.33333 15 7.58583 15 6.66667V4.16667H15.8333C16.7525 4.16667 17.5 4.91417 17.5 5.83333V10C17.5 10.9192 16.7525 11.6667 15.8333 11.6667H9.16667C8.2475 11.6667 7.5 10.9192 7.5 10V5.83333Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3395">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
